export function toArray(nodeList) {
  return [].slice.call(nodeList);
}